export const transformPvIntoPeriodo = (pv) =>
    Number(pv.substring(0, pv.length - 5)).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
